// src/App.tsx

import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { useSelector } from "react-redux";
import { get_auth_process_states } from "./redux/auth/auth.selectors";
import { useEffect, useState } from "react";
import SnackbarWithMessage from "./common/components/Snackbars/SnackbarWithMessage";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'rsuite/dist/rsuite-no-reset.min.css';



function App() {
  // console.log(process.env.REACT_APP_BACKEND_URL);
  // define theme
  const theme = createTheme({
    palette: {
      primary: {
        light: "#63b8ff",
        main: "#084298",
        dark: "#005db0",
        contrastText: "#000",
      },
      secondary: {
        main: "#A6C4DC",
        light: "#EFF6FF",
        dark: "#00867d",
        contrastText: "#000",
      },
      text: {
        primary: "#000",
        secondary: "#426078",
      }
    },
    typography: {
      fontSize: 12
    },
  });

  // const navigate = useNavigate();

  const { auth_error_message, auth_process_failure, auth_process_loading, auth_process_success } = useSelector(get_auth_process_states);

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  useEffect(() => {
    // console.log({ auth_error_message, auth_process_failure, auth_process_loading, auth_process_success });
    if (auth_process_failure && auth_error_message) {
      console.log("auth process failed...");
      set_open_snackbar_with_message({ open: true, message: auth_error_message, severity: "error" });
    }
    if (auth_process_success) {
      set_open_snackbar_with_message({ open: true, message: `Logged in successfully!`, severity: "success" });
    }
  }, [auth_error_message, auth_process_failure, auth_process_loading, auth_process_success]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box height="100vh">
        <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
          set_open_snackbar_with_message({
            open: false,
            message: "",
            severity: "info"
          });
        }} />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Router>
            <AppRoutes />
          </Router>
        </LocalizationProvider>
      </Box>
    </ThemeProvider>
  );
}

export default App;